import React from "react";
import { Modal } from "react-bootstrap";
import Styles from "./BrochureActionModal.module.css";
import cancelIcon from "../Assets/cross.png";
import downloadIcon from "../Assets/download.png";
import shareIcon from "../Assets/share.svg";

export default function BrochureActionModal({
  isOpen,
  onHide,
  onDownload,
  onShare,
}) {
  return (
    <Modal
      show={isOpen}
      onHide={onHide}
      centered
      dialogClassName={Styles.modalDialog}
    >
      <Modal.Body className={Styles.modalBody}>
        <div className={Styles.headerContainer}>
          <p className={Styles.title}>
            e-<span className="orange">Brochure</span>
          </p>
          <div className={Styles.cancelContainer} onClick={onHide}>
            <img src={cancelIcon} alt="close" className={Styles.cancelImg} />
          </div>
        </div>

        <p className={Styles.subtitle}>
          Choose an option to access the e-Brochure:
        </p>

        <div className={Styles.actionsContainer}>
          <div
            className={Styles.actionCard}
            onClick={() => {
              onHide();
              onDownload();
            }}
          >
            <div className={Styles.iconBadge}>
              <img
                src={downloadIcon}
                alt="Download"
                className={Styles.actionIcon}
              />
            </div>
            <div className={Styles.actionDetails}>
              <span className={Styles.actionTitle}>Download</span>
              <span className={Styles.actionDesc}>
                Save PDF to your device
              </span>
            </div>
            <div className={Styles.arrowIcon}>›</div>
          </div>

          <div
            className={Styles.actionCard}
            onClick={() => {
              onHide();
              onShare();
            }}
          >
            <div className={Styles.iconBadge}>
              <img
                src={shareIcon}
                alt="Share"
                className={Styles.actionIcon}
              />
            </div>
            <div className={Styles.actionDetails}>
              <span className={Styles.actionTitle}>Share</span>
              <span className={Styles.actionDesc}>
                Share via WhatsApp, Email, etc.
              </span>
            </div>
            <div className={Styles.arrowIcon}>›</div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
